import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header-helena',
  templateUrl: './header-helena.component.html'
})
export class HeaderHelenaComponent implements OnInit {
  @Input()
  bannerImage: string;
  constructor() { }

  ngOnInit(): void {
  }

}
